import { defineMessages } from 'react-intl';

const scope = 't.component.PortalInfoPage';

export default defineMessages({
	title: {
		id: `${scope}.title`,
		defaultMessage: 'Attendi',
	},
	section: {
		id: `${scope}.section`,
		defaultMessage:
			'Stai per essere reindirizzato al flusso di autenticazione del portale Laka 2.0, che ti permetterà di accedere a tutte le nuove funzionalità evolute',
	},
});
